export default __webpack_public_path__ + "static/media/04_15_25_ESTIMULOS_MCM_01.9b2e8221.jpg";